import Service from '../util/Service';
export default class Tracker {
    constructor() {
        this.service = new Service();
    }
    static init(config) {
        Tracker.config = config;
    }
    fireEvent(event, data = {}, level = 'info') {
        var _a, _b;
        this.service.fireEvent({
            name: 'TRACKING',
            level,
            data: {
                event,
                origin: (_b = (_a = Tracker.config) === null || _a === void 0 ? void 0 : _a.lifecycle) !== null && _b !== void 0 ? _b : 'unknown',
                ...data,
            },
        });
    }
    changePermissions(consentGroups) {
        let data = {};
        consentGroups.forEach((group, index) => {
            const dataMapped = group.consents.reduce((acc, { name, granted = false, features }) => {
                const value = features.length
                    ? features.reduce((acc2, { id, granted: fg = false }) => ({ ...acc2, [id]: fg }), {})
                    : granted;
                return { ...acc, [name]: value };
            }, {});
            data = {
                ...data,
                ...dataMapped,
            };
            const groupName = group.name && group.name !== 'noname' ? group.name : index;
            // set oc-<group> properties
            if (group.oneclick) {
                // calculate oneclick: true only if all granted
                data[`oc-${groupName}`] = group.areAllConsentsAndFeaturesGranted;
            }
        });
        this.fireEvent('changePermissions', data);
    }
    clickCollapsable(groupName) {
        const data = { group: groupName };
        this.fireEvent('clickCollapsable', data);
    }
    comsError(errorMessage) {
        const data = { error_message: errorMessage };
        this.fireEvent('comsError', data, 'error');
    }
}
//# sourceMappingURL=Tracker.js.map